





































































































import Vue from 'vue';
import Component from 'vue-class-component';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import genericapi  from '../assets/ts/genericAPIAxios';
// Vue.prototype.$genericapi = genericapiinstance;

@Component
export default class EBiennialSearch extends Vue {
  private showMaintenanceBanner : boolean = false;
  private maintenanceBannerMessage:string = '';
  private DOSIDNumber: string = '';
  private BusinessName: string = '';
  private errors = [];
  private label = [];
  private configurationName: string = 'PAYMENT';
  private imageFolderPath: string = '';
  private SubmitterInfo: any = {};
  private filingResponse: any = {};
  private validationConfigurationFromDB=[];
  private errorMessagesFromDB=[];
  // private genericInstance = this.$genericapi;

  private created() {

    console.log('Inside created of first page');
    //this.$store.commit('ebiennial/setEBiennialData', null);
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
        //console.log('first pragraph:'+this.label.EBIENNIAL_HOME_PARAGRAPH_1);
        console.log('session timeout from server:'+this.$route.params.sessionTimeOut);
        //if(this.$route.params.sessionTimeOut === 'true'){
        //    this.errors.push(this.getLabelValue('EBIENNIAL_SESSION_TIMEOUT_MESSAGE'));
        //}

      });
    }
    console.log('Fetching configuration from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'CONFIGURATION',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.validationConfigurationFromDB = response.data;
      console.log('after getting the configuration values from database');
      console.log(this.validationConfigurationFromDB);
      this.maintenanceBannerMessage = this.getConfigurationValue('EBIENNIAL_MAINTENANCE_BANEER');
      this.showMaintenanceBanner = (this.getConfigurationValue('EBIENNIAL_SHOW_MAINTENANCE_BANNER') === 'true');
      console.log('show maintenance banner:'+this.showMaintenanceBanner);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });
    
    console.log('Fetching error messages from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'ERROR',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.errorMessagesFromDB = response.data;
      console.log('after getting the error values from database');
      console.log(this.errorMessagesFromDB);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });

    //var url = "https://dev-apps.dos.ny.gov/eBiennialWeb/confirmation?ssl_amount=9.00&ssl_card_short_description=VISA&merchant_defined_data2=13240&merchant_defined_data1=325&ssl_avs_address=28+LIBERTY+ST.&ssl_state=NY&ssl_last_name=SYSTEM&ssl_approval_code=917558&ssl_avs_zip=10005&uid=00d33c2b-f218-4342-ad64-9590dffeb574&show_merchant_id=true&ssl_exp_date=1122&ssl_country=USA&ssl_city=NEW+YORK&ssl_first_name=C&ssl_invoice_number=325&application_profile_id=4&ssl_txn_id=090721ED4-DDF27452-813D-473E-AF57-F49A789AE26E&ssl_transaction_type=SALE&ssl_result=0&ssl_result_message=APPROVAL&ssl_card_number=48**********7774&ssl_avs_response=A&ssl_cvv2_response=M&ssl_txn_time=07%2F09%2F2021+03%3A27%3A29+PM";
    //window.open(url,'mywindow');

    console.log('imageFolderPath:' + this.imageFolderPath);
  }

  private getConfigurationValue(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.validationConfigurationFromDB.length; i++) {
      for (const key in this.validationConfigurationFromDB[i] ) {
        //console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === keyValue) {
          console.log('Matched if:'+this.validationConfigurationFromDB[i][key]);
          return this.validationConfigurationFromDB[i][key];
        }

      }
  }
}

  private getErrorMessage(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.errorMessagesFromDB.length; i++) {
      for (const key in this.errorMessagesFromDB[i] ) {
        if (key === keyValue) {
          console.log('Matched if:'+this.errorMessagesFromDB[i][key]);
          return this.errorMessagesFromDB[i][key];
        }

      }
  }
}


private getLabelValue(keyPassed: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === keyPassed) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
    // console.log('label value:'+this.label[keyPassed]);
    // return this.label[keyPassed];
  }
  private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
    // return this.getLabelValue(columnname);
  }
  private fetchLabels() {
     // return this.$http.get('Ebiennial/GetConfigurationData', {
      //  return genericapi.get('Ebiennial/GetConfigurationData', {
        return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      // console.log('key value:'+response.data.values[response.data.map(function(o) { return o.key; }).indexOf('EBIENNIAL_HOME_PARAGRAPH_1')]);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private search(): void {
    const store = this.$store;
    const http = this.$http;
    this.errors.length = 0;
    if (this.empty(this.DOSIDNumber)) {
      console.log('DOS ID missing');
      this.errors.push('DOS ID missing.');
    }
    if (this.empty(this.BusinessName)) {
      console.log('Business name missing');
      this.errors.push('Business name required.');
    }
    if (this.errors.length) {
   console.log('Missing values');
   return;
  }

// http.post('ebiennial/getBbiennial', {
    http.post('Ebiennial/GetEBiennialSearchData', {
      req: {
       dosId: this.DOSIDNumber,
      entityName: this.BusinessName.toUpperCase(),
      SubmitterInfo: this.SubmitterInfo,
      },
    }).then((response: any) => {
      console.log(response.data);
      response = response.data.eBiennialSearchResult;
      console.log(response);
      // console.log(response.filingData);
      console.log('isSuccess:' + response.requestStatus);
      // store.commit('ebiennial/setEBiennialData', response.filingData);
      if (response.requestStatus === 'Success') {
        if(!this.empty(response.errorMessage)){
          let flag=this.getLabelValue('EBIENNIAL_BYPASS_NOT_ELIGIBLE_FILING');

          if(flag.toLowerCase()=="true"){
            this.populateFilingInfo(response);
            console.log('after populating filing search result in the method');
            console.log(this.filingResponse);
            store.commit('ebiennial/setEBiennialData', this.filingResponse);
            this.$router.push({ name: 'verification' });
          }
          else{
            console.log(response.errorMessage);
            if(response.errorMessage==this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE')){
              console.log('into if');
              this.errors.push(this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE_NEW_MESSAGE'));
            }else{
              this.errors.push(response.errorMessage);
            }

            console.log('after populating filing search result in the method');
            console.log(this.filingResponse);
          }

        }else{
          if(response.farmCorpExemptionFlag.toUpperCase()==='TRUE'){
            var allowFarmCorpExemption = this.getConfigurationValue('ALLOW_FARM_CORP_EXEMPTED_FILING');
            if(allowFarmCorpExemption.toUpperCase() === 'TRUE'){
              this.populateFilingInfo(response);
              console.log('after populating filing search result in the method');
              console.log(this.filingResponse);
              store.commit('ebiennial/setEBiennialData', this.filingResponse);
              this.$router.push({ name: 'verification' });

            }else{
              this.errors.push(this.getErrorMessage('FARM_CORP_EXEMPTED_EBIENNIAL_MESSAGE'));
            }

          }else{
            this.populateFilingInfo(response);
            console.log('after populating filing search result in the method');
            console.log(this.filingResponse);
            store.commit('ebiennial/setEBiennialData', this.filingResponse);
            this.$router.push({ name: 'verification' });
          }
        }
      } else {
          console.log(response.errorMessage);
          if(response.errorMessage==this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE')){
            console.log('into if');
            this.errors.push(this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE_NEW_MESSAGE'));
          }else{
            this.errors.push(response.errorMessage);
          }


      }

    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      this.errors.push(error);
    });
  }
    private reset(): void {
        this.errors.length = 0;
        this.DOSIDNumber = '';
        this.BusinessName = '';
    return;
   }
  private populateFilingInfo(searchResult): void {
    this.filingResponse = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));

    console.log('Inside populateFilinginfo');
    console.log(this.filingResponse);
    console.log(searchResult);
    if (!this.empty(searchResult.ceoInfo.name)) {
      this.filingResponse.ceo.name = searchResult.ceoInfo.name;
    }else{
      this.filingResponse.ceo.name = '';
    }
    if (!this.empty(searchResult.ceoInfo.address.streetAddress)) {
      this.filingResponse.ceo.address.line1 = searchResult.ceoInfo.address.streetAddress;

    }else{
      this.filingResponse.ceo.address.line1 = '';
    }
    if (!this.empty(searchResult.ceoInfo.address.addressLine2)) {
      this.filingResponse.ceo.address.line2 = searchResult.ceoInfo.address.addressLine2;

    }else{
      this.filingResponse.ceo.address.line2 = '';
    }
    if (!this.empty(searchResult.ceoInfo.address.city)) {
      this.filingResponse.ceo.address.city = searchResult.ceoInfo.address.city;

    }else{
       this.filingResponse.ceo.address.city = '';
    }
    if (!this.empty(searchResult.ceoInfo.address.state)) {
      this.filingResponse.ceo.address.state = searchResult.ceoInfo.address.state;

    }else{
      this.filingResponse.ceo.address.state = '';
    }
    if (!this.empty(searchResult.ceoInfo.address.zipCode)) {
      this.filingResponse.ceo.address.zipCode = searchResult.ceoInfo.address.zipCode;

    }else{
      this.filingResponse.ceo.address.zipCode = '';
    }

    if (!this.empty(searchResult.ceoInfo.address.country)) {
      this.filingResponse.ceo.address.country = searchResult.ceoInfo.address.country;
    }else{
      this.filingResponse.ceo.address.country = '';
    }
    console.log('After setting ceo');
    
    if (!this.empty(searchResult.prinExecOfficeInfo.name)) {
      this.filingResponse.prinExecOfficeInfo.name = searchResult.prinExecOfficeInfo.name;

    }else{
      this.filingResponse.prinExecOfficeInfo.name = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.streetAddress)) {
      this.filingResponse.prinExecOfficeInfo.address.line1= searchResult.prinExecOfficeInfo.address.streetAddress;
    }else{
      this.filingResponse.prinExecOfficeInfo.address.line1 = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.addressLine2)) {
      this.filingResponse.prinExecOfficeInfo.address.line2 = searchResult.prinExecOfficeInfo.address.addressLine2;
    }else{
      this.filingResponse.prinExecOfficeInfo.address.line2  = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.city)) {
      this.filingResponse.prinExecOfficeInfo.address.city = searchResult.prinExecOfficeInfo.address.city;
    }else{
      this.filingResponse.prinExecOfficeInfo.address.city = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.state)) {
      this.filingResponse.prinExecOfficeInfo.address.state = searchResult.prinExecOfficeInfo.address.state;

    }else{
      this.filingResponse.prinExecOfficeInfo.address.state = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.zipCode)) {
      this.filingResponse.prinExecOfficeInfo.address.zipCode = searchResult.prinExecOfficeInfo.address.zipCode;

    }else{
      this.filingResponse.prinExecOfficeInfo.address.zipCode = '';
    }
    if (!this.empty(searchResult.prinExecOfficeInfo.address.country)) {
      this.filingResponse.prinExecOfficeInfo.address.country = searchResult.prinExecOfficeInfo.address.country;
    }else{
     this.filingResponse.prinExecOfficeInfo.address.country = '';
    }
    console.log('After setting prinExecOfficeinfo');
    if (!this.empty(searchResult.serviceOfProcessInfo.name)) {
      this.filingResponse.serviceOfProcessInfo.name = searchResult.serviceOfProcessInfo.name;

    }else{
      this.filingResponse.serviceOfProcessInfo.name = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.streetAddress)) {
      this.filingResponse.serviceOfProcessInfo.address.line1 = searchResult.serviceOfProcessInfo.address.streetAddress;
    }else{
      this.filingResponse.serviceOfProcessInfo.address.line1 = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.addressLine2)) {
      this.filingResponse.serviceOfProcessInfo.address.line2 = searchResult.serviceOfProcessInfo.address.addressLine2;
    }else{
      this.filingResponse.serviceOfProcessInfo.address.line2 = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.city)) {
      this.filingResponse.serviceOfProcessInfo.address.city = searchResult.serviceOfProcessInfo.address.city;

    }else{
      this.filingResponse.serviceOfProcessInfo.address.city = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.state)) {
      this.filingResponse.serviceOfProcessInfo.address.state = searchResult.serviceOfProcessInfo.address.state;

    }else{
      this.filingResponse.serviceOfProcessInfo.address.state = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.zipCode)) {
      this.filingResponse.serviceOfProcessInfo.address.zipCode = searchResult.serviceOfProcessInfo.address.zipCode;

    }else{
     this.filingResponse.serviceOfProcessInfo.address.zipCode  = '';
    }
    if (!this.empty(searchResult.serviceOfProcessInfo.address.country)) {
      this.filingResponse.serviceOfProcessInfo.address.country = searchResult.serviceOfProcessInfo.address.country;
    }else{
     this.filingResponse.serviceOfProcessInfo.address.country  = '';
    }
    console.log('After setting serviceofProcessinfo');
    if (!this.empty(searchResult.womenBoardMember.totalNumberOfBoardMembers)) {
      this.filingResponse.womanBoardMember.totalBoardMemberNumber = searchResult.womenBoardMember.totalNumberOfBoardMembers;
    }else{
      this.filingResponse.womanBoardMember.totalBoardMemberNumber = '';
    }
    if (!this.empty(searchResult.womenBoardMember.numberOfWomenBoardMembers)) {
      this.filingResponse.womanBoardMember.totalWomenBoardMemberNumber = searchResult.womenBoardMember.numberOfWomenBoardMembers;
    }else{
      this.filingResponse.womanBoardMember.totalWomenBoardMemberNumber = '';
    }
    if(!this.empty(searchResult.farmCorpExemptionFlag)){
      this.filingResponse.farmCorpExemptionFlag = (searchResult.farmCorpExemptionFlag==='True');
    }else{
      this.filingResponse.farmCorpExemptionFlag = false;
    }
    
    this.filingResponse.filerInfo.name='';
    this.filingResponse.filerInfo.address.line1='';
    this.filingResponse.filerInfo.address.line2='';
    this.filingResponse.filerInfo.address.city='';
    this.filingResponse.filerInfo.address.state='';
    this.filingResponse.filerInfo.address.zipCode='';

    this.filingResponse.signerInformation.signature=false;
    this.filingResponse.signerInformation.signerName='';
    this.filingResponse.signerInformation.signerTitle='';


    this.filingResponse.dosId = searchResult.dosid;
    this.filingResponse.entityName = searchResult.entityName;
    this.filingResponse.entityType = searchResult.entityType;
    this.filingResponse.feeAmount = searchResult.feeAmount;
    this.filingResponse.filingPeriod = searchResult.filingPeriod;
    this.filingResponse.emailForEBiennial = searchResult.emailForNotification;
    if(!this.empty(searchResult.entityType)){
      if(this.filingResponse.entityType.includes('LIMITED PARTNERSHIP') || this.filingResponse.entityType.includes('LIMITED LIABILITY PARTNERSHIP')){
        this.filingResponse.entityTypeInVue = 'LLP';
      }
      else if(this.filingResponse.entityType.includes('LIMITED LIABILITY COMPANY')){
        this.filingResponse.entityTypeInVue = 'LLC';
      }
      else{
        this.filingResponse.entityTypeInVue = 'CORP';
      }
    }

    console.log('After filling up the object');
    console.log(this.filingResponse);

  }
  private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
 }
